import { connect } from 'dva'
import { useEffect } from 'react'
import arcConfig from '@arcgis/core/config'
import EsriMap from '@arcgis/core/Map'
import ImageryLayer from '@arcgis/core/layers/ImageryLayer'
import MapView from '@arcgis/core/views/MapView'
import PropTypes from 'prop-types'
import SceneView from '@arcgis/core/views/SceneView'

import { getConfig } from '../../../lib/config'
import { getCurrentUser } from '../../../services/userProfile'
import { getUser } from '../../../lib/user'
import { isNumeric } from '../../../lib/utils'
import { MAP_LAYER_IDS } from '../../../lib/constants'
import { setBaseLayersVisiblity, setOperationalLayers } from '../../../lib/layers'
import actions from './actions'

/*
  #TODO: Add in things like initializing layers, etc. to this initializer.
  -- TJC - May 06, 2020
*/

function MapInitializer(props) {
  const checkURLForFile = url => {
    const urlParts = url.split('/')
    const lastPart = urlParts[urlParts.length - 1]
    if (lastPart.includes('.pbf') || lastPart.includes('.json') || isNumeric(lastPart)) {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    /*
      #TODO: Store user in model on initial load.
      -- TJC - July 16, 2020
    */
    // have to disable eslint for this block due to the Regex and
    // the Identity call.
    Promise.all([getCurrentUser()]).then(([userRes]) => {
      let geoUrl = getConfig('SERVER_ARC_GIS')
      /* eslint-disable */
      geoUrl = geoUrl.replace('/', '/').replace('.', '.')
      /* eslint-enable */
      if (!userRes.success) {
        userRes.data = getUser()
      }

      const urls = {
        proxy: geoUrl.replace(/geo|maps|proxycache/, 'proxy'),
        maps: geoUrl.replace(/geo|proxycache|proxy/, 'maps'),
        geo: geoUrl.replace(/proxycache|maps|proxy/, 'geo'),
        proxycache: geoUrl.replace(/maps|geo|proxycache|proxy/, 'proxycache')
      }

      arcConfig.request.useIdentity = false
      arcConfig.log.level = 'warn'

      arcConfig.request.interceptors.push({
        id: 'geo',
        urls: new RegExp(`(${urls.geo})(.*)`, 'i'),
      })

      arcConfig.request.useIdentity = false

      arcConfig.request.interceptors.push({
        id: 'maps',
        urls: new RegExp(`(${urls.maps})(.*)`, 'i'),
      })

      arcConfig.request.interceptors.push({
        id: 'proxy',
        urls: new RegExp(`(${urls.proxy})(.*)`, 'i'),
      })

      arcConfig.request.interceptors.push({
        id: 'proxycache',
        urls: new RegExp(`(${urls.proxycache})(.*)`, 'i'),
        before: params => {
          if (params.url.includes('rest/services') && !checkURLForFile(params.url)) {
            params.url += '/'
          }
          if (params.url.includes('rest/services/World_Imagery')) {
            // params.url += '/';
            params.requestOptions.query = {
              ...params.requestOptions.query,
              token: 'AAPK486cc0a24c424ddf9f2824851dae5e89kcKOiFOjHOI8gdBbNvB-PkdVCqK40Z1bAR7bujWzmHRBNuJDdjgPeidRjSTLOEwt'
            }
          }
        }
      })

      const layers = [...props.mapProps.layers]
      if (props.terrainToolsRasterUrl != null && props.terrainToolsRasterUrl !== '') {
        const elevationRaster = new ImageryLayer({
          format: 'lerc',
          id: MAP_LAYER_IDS.terrainAnalysis,
          interpolation: 'nearest',
          opacity: 1.0,
          popupEnabled: false,
          url: props.terrainToolsRasterUrl,
          visible: false
        })
        if (elevationRaster) layers.push(elevationRaster)
      }

      const { baseLayers, contentLayers } = setOperationalLayers({ basemaps: props.basemaps, contentConfig: props.contentConfig })

      const map = new EsriMap({
        ...props.mapProps,
        basemap: {
          baseLayers: [...baseLayers]
        },
        layers: [...contentLayers, ...layers]
      })

      const viewProps = {
        ...props.viewProps,
        constraints: {
          minZoom: 5
        },
        spatialReference: {
          wkid: 3857
        }
      }

      const sceneView = new SceneView({
        ...viewProps,
        container: null,
        map
      })

      sceneView.when(
        () => {},
        err => {
          props.setSceneError(err)
        }
      )

      const mapView = new MapView({
        ...viewProps,
        map
      })

      props.saveRefs(map, mapView, sceneView)

      const timeoutId = setTimeout(() => {
        const baseLayerId = MAP_LAYER_IDS.basemap[props.basemap.name.toLowerCase()]
        setBaseLayersVisiblity({ baseLayers, ids: [baseLayerId], visible: true })
      }, 5000)

      return () => {
        clearTimeout(timeoutId)
      }
    })
  }, [])
  return null
}

MapInitializer.propTypes = {
  basemap: PropTypes.object,
  basemaps: PropTypes.array,
  contentConfig: PropTypes.object,
  terrainToolsRasterUrl: PropTypes.string,
  // actions
  catchLayerError: PropTypes.func,
  mapProps: PropTypes.any,
  saveRefs: PropTypes.func,
  setSceneError: PropTypes.any,
  viewProps: PropTypes.any
}

export default connect(model => {
  const { basemaps } = model.map
  const { config } = model.app
  const basemap = basemaps.find(bm => bm.default) || basemaps[0]
  const contentConfig = config.CONTENT_LAYERS
  const terrainToolsRasterUrl = config.TERRAIN_TOOLS_RASTER
  return {
    basemaps,
    basemap,
    contentConfig,
    terrainToolsRasterUrl
  }
}, actions)(MapInitializer)
